export default __webpack_public_path__ + "static/media/charts2.18fc9104.png";